document.addEventListener('DOMContentLoaded', async () => {
    document.getElementById('change-sku').addEventListener('click', e => {
        const parent = e.target.closest('.tip-container');
        parent.querySelector('.first-step').style.display = "block"
        parent.querySelector('.second-step').style.display = "none"
        document.getElementById('tip-continue').disabled = false
        document.getElementById('tip-loader').style.display = "none"

    })


    if (document.querySelector('.first-step form'))
        document.querySelector('.first-step form').addEventListener('submit', async e => {
            e.preventDefault();
            document.getElementById('tip-continue').disabled = true
            document.getElementById('tip-loader').style.display = "block"
            const formData = new FormData()
            let ymmError = false;
            e.target.querySelectorAll('select[required]').forEach(select => {

                if (select.value == "" || select.value == "-1" || select.value.indexOf('Select') !== -1) {
                    select.value = "";
                    select.reportValidity();
                    select.focus();
                    select.style.border = "1px solid red";
                    ymmError = true
                    document.getElementById('tip-continue').disabled = false
                    document.getElementById('tip-loader').style.display = "none"
                }

            })
            if (ymmError) {
                document.getElementById('tip-continue').disabled = false
                document.getElementById('tip-loader').style.display = "none"
                return false;
            }
            for (let key of e.target.querySelectorAll('[name]')) {
                if (key.selectedOptions) {
                    if (key.value.indexOf("Select") !== -1 || key.value == "-1" || key.value == "") {
                        formData.append(
                            key.getAttribute("name"),
                            ""
                        );
                    }
                    else
                        formData.append(
                            key.getAttribute("name"),
                            key.selectedOptions[0].innerText
                        );
                }
                else
                    formData.append(key.getAttribute('name'), key.value)
            }
            const promise = await fetch('https://awe-conversion.bestworlds.com/api/tips?sku=' + formData.get('sku'));

            //local
            // const promise = await fetch('https://6359-132-255-113-92.ngrok-free.app/api/tips?sku=' + formData.get('sku'));

            const response = await promise.json();
            if (response.items.length == 0) {
                document.querySelector('#alert-tip').innerHTML = "Uh-oh! No replacement tips found. Please <a href=\"/pages/support\">contact support</a> and let's see if we can get this sorted."
                document.getElementById('tip-continue').disabled = false
                document.getElementById('tip-loader').style.display = "none"
                return false;
            }


            e.target.parentElement.style.display = "none";
            // e.target.reset();
            e.target.querySelector('[name="sku"]').value = null;

            const $itemsReplacements = document.querySelector('.tip-container .second-step .tip-items');
            $itemsReplacements.innerHTML = ""

            for (let element of response.items) {

                for (let itemColor of element.tipItems) {
                    if (itemColor.variant) {
                        const itemTemplate = makeItemTip(element, itemColor)
                        let item = document.createElement('div')
                        item.classList = "tip-card";
                        item.innerHTML = itemTemplate;
                        $itemsReplacements.appendChild(item);
                    }

                }


            }

            document.querySelectorAll('.extension-data h5').forEach(el => {
                el.addEventListener('click', (event) => {
                    const parent = event.target.closest('.extension-data');
                    parent.querySelector('.item-lists').classList.toggle('active');
                });
            });
            //make tip grid after queried

            document.querySelector('.tip-container .second-step').style.display = "block";

            const prom = await fetch("https://hooks.zapier.com/hooks/catch/3563261/u98mkx8", {
                method: "POST",
                body: formData,
                redirect: "follow"
            })
            const result = await prom.json();
            document.getElementById('tip-continue').disabled = false
            document.getElementById('tip-loader').style.display = "none"
        })

    // tip sku from URL

    const params = new URLSearchParams(window.location.search)

    if (params.get('tip')) {
        document.querySelector('.tip-container .first-step').style.display = "none";
        const $itemsReplacements = document.querySelector('.tip-container .second-step .tip-items');
        $itemsReplacements.innerHTML = `<div id="tip-loader" class="loader"></div>`
        const promise = await fetch('https://9d3b-132-255-113-91.ngrok-free.app/api/tips?tip=' + params.get('tip'));
        const response = await promise.json();
        $itemsReplacements.innerHTML = ""


        for (let itemColor of response.items.tipItems) {
            const itemTemplate = makeItemTip(response.items, itemColor)
            let item = document.createElement('div')
            item.classList = "tip-card";
            item.innerHTML = itemTemplate;
            $itemsReplacements.appendChild(item);
        }
        document.querySelectorAll('.extension-data h5').forEach(el => {
            el.addEventListener('click', (event) => {
                const parent = event.target.closest('.extension-data');
                parent.querySelector('.item-lists').classList.toggle('active');
            });
        });
        document.querySelector('.tip-container .second-step').style.display = "block";


    }


})

/**
 * 
 * @param {*} element 
 * @param {*} color 
 * @returns 
 */
function makeItemTip(element, color) {
    /**  <div class="extension-data">
                <h5>Specifications <span class="icon-plus arrow"></span></h5>
                 <ul class="item-lists">${element['Bullets At Top'] == '' ? 'Undefined' : element['Bullets At Top']?.split('|').map(element => `<li>${element}</li>`).join('')}</ul>
                 </div> **/

    return `
                    <img src="${color.image ? color.image.src : 'https://cdn.shopify.com/s/files/1/0240/7294/5728/files/chihuaha.png?v=1768930834'}">
                    <h2>${color.variant.title}</h2>
                    <div class="product-sku">SKU: ${color.sku}</div>
                    <div class="tip-qty">
                    TIP QUANTITY: <span>${element['Tip Qty']}</span>
                    </div>
                    <div class="price">
                    PRICE: <span class="compare">$${color.variant.compare_at_price}</span> <span>$${color.variant.price}</span>
                    </div>
                    ${color.variant.inventory_policy === "deny" &&
            color.variant.inventory_quantity <= 0 ? '<strong class="soldout">Sold Out</button>' :
            `<form method="post" action="/cart/add" accept-charset="UTF-8" class="form productView-action" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form"><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="id" value="${color.variant.id}">
                        <button data-action="cart" data-variant-title="${color.name}"  data-variant-sku="${color.variant.id}" id="${color.variant.product_id}" type="submit" name="add" data-btn-addtocart="" class="custom-button--primary" data-add-to-cart-variant="">
                          <span class="button__content">Add To Cart</span>
                        </button>
                      </form>`}`
}

function getSpecs(color, element) {
    console.log(`color, element`,color.sku, element);
    if (color.sku == element["Tip Kit SKU - Chrome Silver"])
        return element['SpecificationsChrome']
    if (color.sku == element["Tip Kit SKU - Diamond Black"])
        return element['SpecificationsBlack']
    if (color.sku == element['Tip Kit SKU - Vapor Blue'])
        return element['SpecificationsVapor']
    return 'undefined'
}